// @flow
const NOW = new Date();

const LAST_HOUR = new Date();
LAST_HOUR.setHours(LAST_HOUR.getHours() - 1);

const LAST_TWELVE_HOURS = new Date();
LAST_TWELVE_HOURS.setHours(LAST_TWELVE_HOURS.getHours() - 12);

// One Day ago
const YESTERDAY = new Date();
YESTERDAY.setDate(YESTERDAY.getDate() - 1);

// 7 Days ago
const LAST_SEVEN_DAYS = new Date();
LAST_SEVEN_DAYS.setDate(LAST_SEVEN_DAYS.getDate() - 7);

// 14 Days ago
const LAST_FOURTEEN_DAYS = new Date();
LAST_FOURTEEN_DAYS.setDate(LAST_FOURTEEN_DAYS.getDate() - 14);

// Month ago
const LAST_MONTH = new Date();
LAST_MONTH.setMonth(LAST_MONTH.getMonth() - 1);

// Three Months Ago
const LAST_THREE_MONTHS = new Date();
LAST_THREE_MONTHS.setMonth(LAST_THREE_MONTHS.getMonth() - 3);

// Six Months Ago
const LAST_SIX_MONTHS = new Date();
LAST_SIX_MONTHS.setMonth(LAST_SIX_MONTHS.getMonth() - 6);

// A Year Ago
const LAST_YEAR = new Date();
LAST_YEAR.setFullYear(LAST_YEAR.getFullYear() - 1);

// Epoch 0 = Dec 1, 1969
const EPOCH_0 = new Date(0);

// -------------------------------\\
const DATE_PRESET_DEFAULTS = [
  { from: YESTERDAY, to: NOW, label: '1D' },
  { from: LAST_SEVEN_DAYS, to: NOW, label: '7D' },
  { from: LAST_MONTH, to: NOW, label: '1M' },
  { from: LAST_SIX_MONTHS, to: NOW, label: '6M' },
  { from: EPOCH_0, to: NOW, label: 'Max' }
];

export default {
  NOW,
  LAST_HOUR,
  LAST_TWELVE_HOURS,
  YESTERDAY,
  LAST_SEVEN_DAYS,
  LAST_MONTH,
  LAST_THREE_MONTHS,
  LAST_SIX_MONTHS,
  LAST_YEAR,
  EPOCH_0,
  LAST_FOURTEEN_DAYS,
  DATE_PRESET_DEFAULTS
};



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/utils/Date.constants.js